import React from "react";
import MainLayout from "./Layouts/MainLayout";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter } from "react-router-dom";
type Props = {};

const App = (props: Props) => {
  return (
    
      <MainLayout />
   
  );
};

export default App;
